/**
 * Selective Redux selectors for block components to reduce re-renders.
 * Each block component should subscribe only to the data it needs.
 */

/**
 * Factory selector: returns a selector function that gets only the data
 * a specific node (block component) needs from the chatbot state.
 * 
 * @param {string} nodeId - The node/block ID
 * @returns {function} A selector function to use with useSelector(selector, shallowEqual)
 */
export const createSelectNodeData = (nodeId) => (state) => ({
  block: state.chatbot.blocks[nodeId],
  start: state.chatbot.start,
  review: state.chatbot.review,
  progress: state.chatbot.progress,
});

/**
 * Selector for getting block variables (used in editors/block panels).
 * Returns all block variables for use in select dropdowns, etc.
 * Use this in side panels and editors that need the full variable list.
 */
export const selectBlockVariables = (state) => {
  const variables = [];
  Object.values(state.chatbot.blocks || {}).forEach((item) => {
    if (item.type !== 'conditionBlock') {
      if (item.data?.hasOwnProperty('variable')) {
        variables.push({
          label: item.data.variable,
          value: item.data._id,
          content: item.data._id,
          id: item.data._id,
        });
        if (item.type === 'decisionBlock') {
          variables.push(
            {
              label: `${item.data.variable}-dateofclick`,
              value: item.data.variable,
              content: `${item.data.variable} Date of click`,
            },
            {
              label: `${item.data.variable}-timeofclick`,
              value: item.data.variable,
              content: `${item.data.variable} Time of click`,
            }
          );
        }
      }
      if (item.type === 'calculationBlock') {
        variables.push(
          {
            label: `${item.data.variable}-result`,
            value: item.data.variable,
            content: `${item.data.variable} Result`,
          }
        );
      }
    }
  });
  return variables;
};
